import React from "react";
import styled from "styled-components";

const SkeletonContainer = styled.div`
  padding: 20px;
  width: 100%;
`;

const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 10px;
  border-bottom: 1px solid #e0e0e0;
  gap: 15px;
`;

const SkeletonBox = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s ease-in-out infinite;
  border-radius: 4px;
  height: 20px;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

const SkeletonHeaderRow = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 10px;
  gap: 15px;
  background: var(--color-primary-dark);
  border-radius: 10px 10px 0 0;
  margin-bottom: 4px;
`;

const SkeletonHeaderBox = styled.div`
  background: color-mix(in srgb, #ffffff 25%, transparent);
  border-radius: 4px;
  height: 16px;
`;

const TableSkeletonLoader = ({ rows = 5, columns = 7 }) => {
  return (
    <SkeletonContainer>
      <SkeletonHeaderRow>
        {Array.from({ length: columns }).map((_, colIndex) => (
          <SkeletonHeaderBox
            key={colIndex}
            style={{
              width:
                colIndex === 0
                  ? "40px"
                  : colIndex === 1
                  ? "200px"
                  : colIndex === 2
                  ? "150px"
                  : colIndex === 3
                  ? "120px"
                  : colIndex === 4
                  ? "150px"
                  : colIndex === 5
                  ? "150px"
                  : "100px",
              flex: colIndex > 0 ? 1 : "none",
            }}
          />
        ))}
      </SkeletonHeaderRow>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <SkeletonRow key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <SkeletonBox
              key={colIndex}
              style={{
                width:
                  colIndex === 0
                    ? "40px"
                    : colIndex === 1
                    ? "200px"
                    : colIndex === 2
                    ? "150px"
                    : colIndex === 3
                    ? "120px"
                    : colIndex === 4
                    ? "150px"
                    : colIndex === 5
                    ? "150px"
                    : "100px",
                flex: colIndex > 0 ? 1 : "none",
              }}
            />
          ))}
        </SkeletonRow>
      ))}
    </SkeletonContainer>
  );
};

export default TableSkeletonLoader;
